<template>
  <div class="login">
    <div class="login__content">
      <a href="#" class="login__logo"></a>
      <router-view></router-view>
    </div>
  </div>
  <AppLangChange class="locale" color="#000" />
</template>

<script setup>
import AppLangChange from '@/app/base/components/AppLangChange.vue'
import { useStore } from 'vuex'

const store = useStore()
store.commit('SET_USER', null)

</script>

<style lang="scss" scoped>
.locale {
  position: absolute;
  top: 2rem;
  right: 2rem;
}
</style>
